import { useEffect } from 'react';
import { useDialogStore } from '../store/dialogStore';

function dialogIcon(variant: string): string {
  switch (variant) {
    case 'danger':
      return 'delete';
    case 'alert':
      return 'info';
    default:
      return 'help';
  }
}

export function AppDialogHost() {
  const current = useDialogStore((s) => s.current);
  const close = useDialogStore((s) => s.close);

  const isAlert = current?.variant === 'alert';
  const isDanger = current?.variant === 'danger';

  useEffect(() => {
    if (!current) return;
    function onKey(ev: KeyboardEvent) {
      if (ev.key === 'Escape') {
        ev.preventDefault();
        close(isAlert);
      }
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [current, close, isAlert]);

  if (!current) return null;
  const confirmLabel = current.confirmLabel ?? (isAlert ? 'OK' : 'Confirm');
  const cancelLabel = current.cancelLabel ?? 'Cancel';

  return (
    <div
      className="app-dialog-backdrop"
      role="presentation"
      onClick={() => close(isAlert)}
    >
      <div
        className={`app-dialog hk-confirm-dialog ${isDanger ? 'hk-confirm-dialog--danger' : ''}`}
        role="alertdialog"
        aria-modal
        aria-labelledby="app-dialog-title"
        aria-describedby={current.message ? 'app-dialog-message' : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="hk-confirm-dialog__body">
          <div
            className={`hk-confirm-dialog__icon ${isDanger ? 'hk-confirm-dialog__icon--danger' : 'hk-confirm-dialog__icon--primary'}`}
            aria-hidden
          >
            <span className="material-symbols-outlined">{dialogIcon(current.variant)}</span>
          </div>
          <h2 id="app-dialog-title">{current.title}</h2>
          {current.message ? (
            <p id="app-dialog-message" className="hk-confirm-dialog__lead">
              {current.message}
            </p>
          ) : null}
          <div className="hk-confirm-dialog__actions">
            {!isAlert ? (
              <button
                type="button"
                className="hk-confirm-dialog__btn hk-confirm-dialog__btn--cancel"
                onClick={() => close(false)}
              >
                {cancelLabel}
              </button>
            ) : null}
            <button
              type="button"
              className={`hk-confirm-dialog__btn ${
                isDanger
                  ? 'hk-confirm-dialog__btn--danger'
                  : 'hk-confirm-dialog__btn--primary'
              }`}
              autoFocus
              onClick={() => close(true)}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
